import { render } from "./SamediCta.vue?vue&type=template&id=416aeb36&scoped=true&lang=pug"
import script from "./SamediCta.vue?vue&type=script&lang=js"
export * from "./SamediCta.vue?vue&type=script&lang=js"

import "./SamediCta.vue?vue&type=style&index=0&id=416aeb36&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-416aeb36"

export default script